export const CONSTRAINT_FORM_CATEGORIES = [
  'resource',
  'technical',
  'organizational',
  'external',
  'process',
  'decision',
  'other',
];

export const CONSTRAINT_FORM_PRIORITIES = ['high', 'medium', 'low'];

export const CONSTRAINT_FORM_TYPE_CROSS = 'bereichsuebergreifend';
export const CONSTRAINT_FORM_TYPE_INTERN = 'intern';

export function emptyConstraintDialogForm() {
  return {
    title: '',
    category: '',
    type: '',
    priority: 'medium',
    description: '',
    milestoneId: '',
    ownerUserId: '',
  };
}

export function mapConstraintApiToDialog(constraint) {
  if (!constraint) return emptyConstraintDialogForm();
  return {
    title: constraint.title || '',
    category: constraint.category || '',
    type: constraint.type || '',
    priority: constraint.priority || 'medium',
    description: constraint.description || '',
    milestoneId: constraint.milestoneId || '',
    ownerUserId: constraint.ownerUserId || '',
  };
}

export function mapConstraintDialogToApiPayload(form) {
  const payload = {
    title: String(form.title || '').trim(),
    description: String(form.description || '').trim(),
    ownerUserId: String(form.ownerUserId || ''),
    priority: form.priority || 'medium',
    category: form.category,
    type: form.type,
  };
  if (form.milestoneId) {
    payload.milestoneId = form.milestoneId;
  }
  return payload;
}

export function validateConstraintDialogForm(form, t) {
  const errors = {};
  if (!String(form.title || '').trim()) {
    errors.title = t('UserProjects.constraintDialog.validation.titleRequired');
  }
  if (!form.category) {
    errors.category = t('UserProjects.constraintDialog.validation.categoryRequired');
  }
  if (!form.type) {
    errors.type = t('UserProjects.constraintDialog.validation.typeRequired');
  }
  if (!form.priority) {
    errors.priority = t('UserProjects.constraintDialog.validation.priorityRequired');
  }
  if (!String(form.ownerUserId || '').trim()) {
    errors.ownerUserId = t('UserProjects.constraintDialog.validation.ownerRequired');
  }
  if (String(form.description || '').length > 500) {
    errors.description = t('UserProjects.constraintDialog.validation.descriptionMax');
  }
  return errors;
}

export function displayConstraintTitle(constraint) {
  const title = String(constraint?.title || '').trim();
  if (title) return title;
  const text = String(constraint?.description || '').trim();
  if (!text) return '—';
  const firstLine = text.split('\n')[0];
  return firstLine.length > 120 ? `${firstLine.slice(0, 120)}…` : firstLine;
}

export function isActiveConstraintStatus(status) {
  return status === 'open' || status === 'in_progress';
}
